import { Directive, ElementRef, Input, NgZone, OnDestroy, OnInit, inject } from '@angular/core';
import { ScrollStateService } from '../services/scroll-state.service';

@Directive({
  selector: '[appHideShellOnScroll]',
  standalone: true,
})
export class HideShellOnScrollDirective implements OnInit, OnDestroy {
  private elRef = inject(ElementRef<HTMLElement>);
  private zone = inject(NgZone);
  private scroll = inject(ScrollStateService);

  /** Stable key per scroll container, e.g. 'blog-details-light' */
  @Input() scrollKey!: string;

  /** Master switch */
  @Input() shellEnabled: boolean = true;

  /** What should react to scroll? */
  @Input() hideDock: boolean = false;
  @Input() hideNav: boolean = false;
  @Input() hideFooter: boolean = false;

  private onScrollBound?: EventListener;

  ngOnInit(): void {
    const el = this.elRef.nativeElement;

    if (!this.scrollKey) return;

    this.scroll.resetScrollKey(this.scrollKey, el.scrollTop);

    this.zone.runOutsideAngular(() => {
      this.onScrollBound = () => {
        if (!this.shellEnabled) return;

        const top = el.scrollTop;
        const scrollHeight = el.scrollHeight;
        const clientHeight = el.clientHeight;

        if (this.hideDock) {
          this.scroll.updateDockByScroll(this.scrollKey, top, scrollHeight, clientHeight);
        }

        if (this.hideNav) {
          this.scroll.updateNavByScroll(this.scrollKey, top, scrollHeight, clientHeight);
        }

        if (this.hideFooter) {
          this.scroll.updateFooterByScroll(this.scrollKey, top, scrollHeight, clientHeight);
        }
      };

      el.addEventListener('scroll', this.onScrollBound, { passive: true });
    });
  }

  ngOnDestroy(): void {
    const el = this.elRef.nativeElement;
    if (this.onScrollBound) {
      el.removeEventListener('scroll', this.onScrollBound);
    }
  }
}
